"use client";

import { useCategories } from "@/app/hooks/use-categories";
import { CategoriesPage } from "@/app/components/layout/categories-page";
import { AlbumsPageSkeleton } from "@/app/components/skeletons/page-skeletons";

export default function AlbumsPage() {
  const { categories, isLoading } = useCategories();

  if (isLoading) {
    return <AlbumsPageSkeleton />;
  }

  return (
    <CategoriesPage
      title="Baskı"
      description="En güzel anılarınız için profesyonel baskı seçenekleri"
      items={categories?.printCategories}
      baseUrl="/baski"
      isLoading={isLoading}
    />
  );
}